<template>
    <div style="height:100%">
        <div id="csContainer">
          <div class="fogdiv">
             <el-checkbox class="shadow" size="small " v-model="checked" label="火" border></el-checkbox>
          </div>
        </div>
    </div>
</template>

<script>
    import util from "../../components/util"

    export default {
        data () {
            return {
                    checked: false,
                    viewer:null
                }
        },
        watch:{
            checked:function (val) {
                if(val===true){
                    this.fire(this.viewer)
                }else if(val===false){
                    this.viewer.scene.primitives.removeAll();
                }
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
               this.viewer = util.getViewer("csContainer", {
                    shouldAnimate: true,
                    animation: true
                });
                // this.fire(this.viewer);
                this.zoomToFire(this.viewer);
            },
            fire(viewer) {
                let staticPosition = Cesium.Cartesian3.fromDegrees(116.34516786934411, 39.99753297677145, 3.614538127977399);
                let entity44 = viewer.entities.add({
                    position: staticPosition
                });
                viewer.scene.primitives.add(new Cesium.ParticleSystem({
                    image: require('./img/fire.png'),
                    startColor: Cesium.Color.RED.withAlpha(0.7),
                    endColor: Cesium.Color.YELLOW.withAlpha(0.3),
                    startScale: 0,
                    endScale: 10,
                    //设定粒子寿命可能持续时间的最小限值(以秒为单位)，在此限值之上将随机选择粒子的实际寿命。
                    minimumParticleLife: 1,
                    maximumParticleLife: 6,
                    minimumSpeed: 1,
                    maximumSpeed: 4,
                    imageSize: new Cesium.Cartesian2(55, 55),
                    // Particles per second.
                    emissionRate: 4,
                    lifetime: 160.0,
                    //cesium内置的发射器，圆形发射器，因此参数是一个半径值
                    // 还有锥形发射器，new Cesium.ConeEmitter(Cesium.Math.toRadians(45.0))
                    // 长方形发射器，new Cesium.BoxEmitter(new Cesium.Cartesian3(1.0, 1.0, 1.0))
                    // 半球发射器，new Cesium.SphereEmitter(0.5)
                    emitter: new Cesium.CircleEmitter(5.0),
                    //将粒子系统从模型转换为世界坐标的4x4变换矩阵
                    modelMatrix: this.computeModelMatrix(entity44, Cesium.JulianDate.now()),
                    //在粒子系统局部坐标系中变换粒子系统发射器的4x4变换矩阵。
                    emitterModelMatrix: this.computeEmitterModelMatrix()
                }));
            },
            computeModelMatrix(entity, time) {
                let position = Cesium.Property.getValueOrUndefined(entity.position, time);
                let modelMatrix = Cesium.Transforms.eastNorthUpToFixedFrame(position);
                return modelMatrix;
            },
            computeEmitterModelMatrix() {
                let hpr = Cesium.HeadingPitchRoll.fromDegrees(0, 0, 0);
                let trs = new Cesium.TranslationRotationScale();
                trs.translation = Cesium.Cartesian3.fromElements(2.5, 4, 1);
                trs.rotation = Cesium.Quaternion.fromHeadingPitchRoll(hpr);
                let result = Cesium.Matrix4.fromTranslationRotationScale(trs);
                return result
            },
            zoomToFire(viewer) {
                let heading = 2.1209270232057342;
                let pitch = -0.8235007274468953;
                let roll = 0.004138849016427137;
                viewer.camera.setView({
                    destination: {
                        x: -2170155.379830758,
                        y: 4386687.685815611,
                        z: 4079957.6964474698
                    },
                    orientation: {
                        heading,
                        pitch,
                        roll
                    }
                });
            }

        }
    }
</script>

<style scoped>
    #csContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
    .fogdiv {
        position: absolute;
        margin-left: 25px;
        margin-top: 7px;
        z-index: 999;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .shadow{
        color:white !important;
    }
</style>
